import { BpService } from "./types";

// Blueprint services whose catalog service has no approved snapshot. Services
// without a catalog link are not flagged: there is nothing to approve.
export const unapprovedServiceIds = (
  services: BpService[],
  approvedIds: string[]
): Set<string> => {
  const approved = new Set(approvedIds);
  return new Set(
    services
      .filter((s) => s.catalogId && !approved.has(s.catalogId))
      .map((s) => s.id)
  );
};
